import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-black/90 backdrop-blur-md border-b border-red-900/30'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="/logo2.png"
              alt="El Último Redentor"
              className="h-12 w-12 object-contain nav-logo-clean"
            />
          </div>

          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('app')}
              className="text-gray-300 hover:text-orange-500 transition-colors duration-300 font-medium"
            >
              La App
            </button>
            <button
              onClick={() => scrollToSection('universo')}
              className="text-gray-300 hover:text-orange-500 transition-colors duration-300 font-medium"
            >
              El Universo
            </button>
            <button
              onClick={() => scrollToSection('descarga')}
              className="text-gray-300 hover:text-orange-500 transition-colors duration-300 font-medium"
            >
              Descargar
            </button>
          </nav>

          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-red-900/30 pt-4">
            <nav className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('app')}
                className="text-gray-300 hover:text-orange-500 transition-colors duration-300 text-left font-medium"
              >
                La App
              </button>
              <button
                onClick={() => scrollToSection('universo')}
                className="text-gray-300 hover:text-orange-500 transition-colors duration-300 text-left font-medium"
              >
                El Universo
              </button>
              <button
                onClick={() => scrollToSection('descarga')}
                className="text-gray-300 hover:text-orange-500 transition-colors duration-300 text-left font-medium"
              >
                Descargar
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
